module.exports = __webpack_public_path__ + "static/img/cont6.6d8d6dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont6.jpg
// module id = ypt7
// module chunks = 0